// @flow

import { connect } from 'react-redux';
import { createSelector, type OutputSelector } from 'reselect';

import {
  selectCartIsCommitted,
  selectCartUUID as selectCartId,
  selectCartConfigurations as selectConfigurations,
  type CartConfiguration as Configuration,
  type Process,
} from '@gandi/cart';

import { getSetupOverviewUrl } from 'src/Cart/Setup/modules/helpers';

import type { FullState } from '../../../../../../types';

export type OwnProps = {
  process: Process,
};

type StateProps = {
  committed: boolean,
  templateChangeURL: string,
  configuration: void | Configuration,
};

export type DomainConfigurationProps = {
  ...OwnProps,
  ...StateProps,
};

const selectProcess = (_: FullState, process: Process) => process;
const selectConfiguration: OutputSelector<
  FullState,
  Process,
  void | Configuration,
> = createSelector(
  [selectConfigurations, selectProcess],
  (cartConfigurations, process) =>
    cartConfigurations.find(
      ({ product_type: productType, process: _process }) =>
        productType === 'domain' && _process === process,
    ),
);

const mapStateToProps = (state: FullState, ownProps: OwnProps): StateProps => ({
  committed: selectCartIsCommitted(state),
  configuration: selectConfiguration(state, ownProps.process),
  // $FlowFixMe Process type is incompatible with the restricted CreateOrTransfer type
  templateChangeURL: getSetupOverviewUrl(selectCartId(state), ownProps.process),
});

// $FlowFixMe[cannot-resolve-name]
// $FlowFixMe[incompatible-call]
export default (connect(mapStateToProps): Connector<
  mixed,
  OwnProps,
  // $FlowFixMe[cannot-resolve-name]
  MergeOPSP<OwnProps, StateProps, mixed>,
>);
